import { Component } from '@angular/core';

@Component({
	selector: 'app-legal',
	templateUrl: './legal.component.html',
	styleUrls: ['./legal.component.css']
})
export class LegalComponent {

	constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/legal/legal.component.ts